import clsx from 'clsx';
import { FaAngleDown, FaAngleRight } from 'react-icons/fa';

interface AccordionHeaderProps {
  header: () => JSX.Element;
  open: boolean;
  onClick: () => void;
  classNames?: string;
  disabled: boolean;
  headerBgColor?: string;
}

export const AccordionHeader = ({
  open,
  header: HeaderComponent,
  onClick,
  disabled,
  classNames,
  headerBgColor = 'bg-day-light-5',
}: AccordionHeaderProps) => {
  return (
    <>
      <button
        onClick={onClick}
        className={clsx(
          'flex justify-between items-center w-full transition duration-300 cursor-pointer rounded-md text-sm relative',
          { 'font-bold': open },
          `hover:bg-day-light-3 ${headerBgColor} text-day-neutral-subtle`,
        )}
      >
        <div className={clsx('w-full text-left z-0 py-2 px-3', classNames)}>
          <HeaderComponent />
        </div>
        {!disabled && (
          <div className="absolute right-0 px-3">{open ? <FaAngleDown /> : <FaAngleRight />}</div>
        )}
      </button>
    </>
  );
};
